module.exports = __webpack_public_path__ + "static/media/invite-area-creation-logo.212362f8.webp";